import { authenticate } from '@chr/online-shared-microsite-core';
import { getAppConfig } from './helpers/app-config-helper';

export const index = (async () => {
  const code = new URLSearchParams(window.location.search).get('code');
  const appConfig = await getAppConfig();

  try {
    if (code) {
      await authenticate(appConfig);

      const uri = localStorage.getItem('NavisphereOnline.redirectURI');
      localStorage.removeItem('NavisphereOnline.redirectURI');

      if (uri) {
        window.location.assign(uri);
      } else {
        const productsUri = appConfig.productsUri;
        window.location.assign(productsUri);
      }
    } else {
      window.location.assign(appConfig.productsUri);
    }
  } catch (error) {
    console.error('Error:', error);
    return;
  }
})();
